
import { Component, Mixins } from "vue-property-decorator";
import { IUserDefinedInformationKey } from "../../../../../../documaker/domain/format/objects";
import { instanceOfIUserDefinedInformationKeyPropertyEditable, IUserDefinedInformationKeyPropertyEditable } from "../../../../../domain/editableFormat/properties";
import { IUserDefinitionSpecification } from "../../../../../domain/editableFormat";
import { CommonComponentsContainer } from "../../contents";

@Component
export default class UserDefinedInformationKeyPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IUserDefinedInformationKeyPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IUserDefinedInformationKeyPropertyEditable) => T, defaultValue: T) => T;
  // CommonComponentsAccessibleMixinと同時に使う事.CommonComponentsAccessibleMixin利用APIの宣言.
  getCommonComponents: () => CommonComponentsContainer;

  get isUserDefinedInformationKeyEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIUserDefinedInformationKeyPropertyEditable(s) && s.userDefinedInformationKey().isEditable(), false);
  }

  get isUserDefinedInformationKeySelectable(): boolean {
    return this.isUserDefinedInformationKeyEditable
        && (1 < this.selectableUserDefinedInformations.length);
  }

  get userDefinedInformationName(): string {
    return this.readPropertyOrDefault(s => s.userDefinedInformationKey().getValue().column, "");
  }

  get userDefinedInformationKey(): IUserDefinedInformationKey {
    return this.readPropertyOrDefault(s => s.userDefinedInformationKey().getValue(), null);
  }

  set userDefinedInformationKey(value: IUserDefinedInformationKey) {
    this.writePropertyWhenValid(s => s.userDefinedInformationKey().setValue(value));
  }

  get selectableUserDefinedInformations(): IUserDefinitionSpecification[] {
    return this.readPropertyOrDefault(s => s.getSelectableUserDefinedInformations(), []);
  }
  
  async selectUserDefinedInformation(): Promise<void> {
    const selectedKey = await this.getCommonComponents().getDialogs().getUserDefinedInformationSelectDialog().show(
      this.selectableUserDefinedInformations,
      this.userDefinedInformationKey);
    if (!selectedKey) {
      return;
    }
    this.userDefinedInformationKey = selectedKey;
  }
}
